import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { PeppolFromPeppolDocHdrQueueContainerModel } from '../../../../../../models/aggregates/e-invoice/peppol/bl_ppl_from_peppol_doc_hdr_queue.model';

@Injectable({
  providedIn: 'root'
})
export class PeppolFromPeppolDocHdrQueueService extends BaseApiTemplateService<PeppolFromPeppolDocHdrQueueContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + Core2Config.PEPPOL_PREFIX + 'from-peppol-doc-hdr-queues/backoffice-ep'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + Core2Config.PEPPOL_PREFIX + 'from-peppol-doc-hdr-queues/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + Core2Config.PEPPOL_PREFIX + 'from-peppol-doc-hdr-queues/backoffice-ep'
    this.httpClient = http;
  }
}
